<template>
  <div>
    <traffic-side-nav></traffic-side-nav>
    <v-content transition="slide-x-transition">
      <!--<router-view></router-view>-->
      <slot />
    <!-- <module-list /> -->
    </v-content>
    <Footer />
  </div>
</template>
<script>
//import AppNavigation from "@/components/AppNavigation";
import TrafficSideNav from "@/components/layout/traffic_side_nav";
import Footer from "@/components/layout/footer";
import "vuejs-noty/dist/vuejs-noty.css";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from "moment";
export default {
  name: "App",
  components: {
    TrafficSideNav,
    Footer
  },
  data: () => ({
    current_year: moment().format("YYYY")
  })
};
</script>
